/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { dateFormat } from "utils/constants";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import { Loading } from "notiflix/build/notiflix-loading-aio";
import { Confirm } from "notiflix/build/notiflix-confirm-aio";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Close from "@mui/icons-material/Close";
import {
  useGetAllResellerCreditsQuery,
  useDeleteResellerCreditsMutation,
} from "services/credit_note";
import { useGetAllCompaniesQuery } from "services/companies";
import { globalCountry } from "store/entities/countries";
import EditCreditNoteDialog from "./EditCreditNoteDialog";
import AddCreditNoteDialog from "./AddCreditNoteDialog";
import { tables } from "utils/constants";
import { Notify } from "notiflix/build/notiflix-notify-aio";
import ApplyCreditNoteDialog from "./ApplyCreditNoteDialog";
import { Badge } from "@mui/material";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";

function CreditNote() {
  const selectedCountry = useSelector(globalCountry);
  const { data: companiesList = [] } = useGetAllCompaniesQuery(selectedCountry.id);
  const { data: tableDate = [] } = useGetAllResellerCreditsQuery(selectedCountry.id);
  const [deleteCreditNote] = useDeleteResellerCreditsMutation();

  useEffect(() => {
    Loading.dots({
      svgColor: "rgba(159, 3, 3, 0.8)",
    });
    if (companiesList && companiesList.length > 0 && tableDate) Loading.remove(500);
  }, [companiesList, tableDate]);

  const handleDelete = async (id) => {
    Loading.dots({
      svgColor: "rgba(159, 3, 3, 0.8)",
    });
    try {
      var body = {
        id,
        countryId: selectedCountry.id,
      };
      deleteCreditNote(body).then((response) => {
        Notify.success(response.message);
      });
    } catch (e) {
      console.log(e);
    } finally {
      Loading.remove(500);
    }
  };

  return (
    <Card>
      <CardHeader
        title={<MDTypography color="info">Credit Notes</MDTypography>}
        action={<AddCreditNoteDialog companiesList={companiesList} />}
      />
      <CardContent>
        <DataTable
          id={tables.CREDITNOTES}
          columns={[
            {
              Header: "Company Name",
              Cell: ({ row: { original } }) => original.reseller.companies.name,
            },
            {
              Header: "Reseller Name",
              Cell: ({ row: { original } }) =>
                original.reseller.first_name + " " + original.reseller.last_name,
            },

            {
              Header: "Amount",
              accessor: "amount",
            },
            {
              Header: "Date",
              accessor: "datetime",
              Cell: ({ row: { original } }) => moment(original.datetime).format(dateFormat),
            },
            {
              Header: "Order ID",
              accessor: "order_id",
            },
            {
              Header: "Actions",
              accessor: "actions",
              disableSortBy: true,
              disableFilters: true,
              show: true,
              align: "right",
              // eslint-disable-next-line react/display-name
              Cell: ({ row: { original } }) =>
                original.applied_order_id == null || original.applied_amount < original.amount ? (
                  <div className="actions-right">
                    <ApplyCreditNoteDialog creditData={original} />
                    <EditCreditNoteDialog creditData={original} companiesList={companiesList} />
                    <Tooltip title="Delete" sx={{ ml: 1 }} placement="top">
                      <IconButton
                        aria-label="view"
                        size="small"
                        onClick={() => {
                          Confirm.show(
                            `Please Confirm`,
                            "Are you sure you want to delete?",
                            "Yes",
                            "No",
                            () => {
                              handleDelete(original.id);
                            },
                            () => {},
                            {}
                          );
                        }}
                      >
                        <Close color="error" fontSize="inherit" />
                      </IconButton>
                    </Tooltip>
                  </div>
                ) : (
                  <MDBox>
                    <MDBadge
                      badgeContent={"Creditnote Applied - " + original.applied_order_id}
                      variant="gradient"
                      size="sm"
                    />
                  </MDBox>
                ),
            },
          ]}
          data={tableDate}
          isSorted={true}
          entriesPerPage={false}
          showTotalEntries={false}
          hideColumnSelection={false}
          noEndBorder
          canSearch
        />
      </CardContent>
    </Card>
  );
}

export default CreditNote;
